export default __webpack_public_path__ + "static/media/icon-services-access-control.c7c2bf54.svg";